module.exports = __webpack_public_path__ + "static/img/alld_en.33cd061.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/alld_en.png
// module id = CWnh
// module chunks = 80